export const Flag = Object.freeze({
  ACTIVE: 1,
})

export const Status = Object.freeze({
  WAITING_APPROVAL: 0,
})

export default { Flag, Status }
